/**
 * @flow
 * @relayHash 19c444abeceaf8ae3b852a0d8b1725fd
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ClientDetail_SetClientFlag_MutationVariables = {|
  input: {
    travelerId?: ?string;
    checkbox?: ?string;
    value?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type ClientDetail_SetClientFlag_MutationResponse = {|
  +setClientFlag: ?{|
    +traveler: ?{|
      +insideCircle: boolean;
      +lowPriority: boolean;
      +needsTraining: boolean;
      +needsVetting: boolean;
      +fired: boolean;
      +prospect: boolean;
      +acceptPolicies: boolean;
      +acceptPoliciesTimestamp: ?any;
      +highPriority: boolean;
    |};
  |};
|};
*/


/*
mutation ClientDetail_SetClientFlag_Mutation(
  $input: SetClientFlagInput!
) {
  setClientFlag(input: $input) {
    traveler {
      insideCircle
      lowPriority
      needsTraining
      needsVetting
      fired
      prospect
      acceptPolicies
      acceptPoliciesTimestamp
      highPriority
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "SetClientFlagInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientDetail_SetClientFlag_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "SetClientFlagInput!"
          }
        ],
        "concreteType": "SetClientFlagPayload",
        "name": "setClientFlag",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "traveler",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "insideCircle",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "lowPriority",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "needsTraining",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "needsVetting",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "fired",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "prospect",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "acceptPolicies",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "acceptPoliciesTimestamp",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "highPriority",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ClientDetail_SetClientFlag_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "SetClientFlagInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "ClientDetail_SetClientFlag_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "SetClientFlagInput!"
          }
        ],
        "concreteType": "SetClientFlagPayload",
        "name": "setClientFlag",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "traveler",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "insideCircle",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "lowPriority",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "needsTraining",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "needsVetting",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "fired",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "prospect",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "acceptPolicies",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "acceptPoliciesTimestamp",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "highPriority",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation ClientDetail_SetClientFlag_Mutation(\n  $input: SetClientFlagInput!\n) {\n  setClientFlag(input: $input) {\n    traveler {\n      insideCircle\n      lowPriority\n      needsTraining\n      needsVetting\n      fired\n      prospect\n      acceptPolicies\n      acceptPoliciesTimestamp\n      highPriority\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Clients/__generated__/ClientDetail_SetClientFlag_Mutation.graphql.js